// Generated by scripts/build-ui-icons.mjs.
export { Trash as default } from "../ui/glyphs-7";
